var React = require('react');

function ChatIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.6663 0.371094C25.5073 0.371094 26.9996 1.8503 26.9996 3.67499V15.569C26.9996 17.3937 25.5073 18.8729 23.6663 18.8729H20.9996V26.8023L11.343 18.8729H3.66634C1.82539 18.8729 0.333008 17.3937 0.333008 15.569V3.67499C0.333008 1.8503 1.82539 0.371094 3.66634 0.371094H23.6663Z","fill":"white"}));
}

ChatIconInline.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 27 27","fill":"currentColor","stroke":"currentColor","strokeWidth":"0"};

module.exports = ChatIconInline;

ChatIconInline.default = ChatIconInline;
